module.exports = __webpack_public_path__ + "static/media/Customization-selected-icon.6097a12b.svg";